import { ofType } from 'redux-observable';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  addedWorkflowAction,
  setCurrentWorkflowAction
} from '../../reducers/actions';
import { WorkflowService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_WORKFLOW),
    switchMap(action =>
      WorkflowService.create(action.workflow, store).pipe(
        switchMap(data =>
          concat(
            of(addedWorkflowAction(data)),
            of(setCurrentWorkflowAction(data))
          )
        ),
        catchError(retryAuthentication(action$, 'epics/workflows/addWorkflow'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/workflows/addWorkflow.js